import { classFilter } from '@shieldpay/theme-provider-ui/utilities';

import AtomSrc from '../../../images/bank-atom.svg';
import BankOfScotlandSrc from '../../../images/bank-bank-of-scotland.svg';
import BarclaysSrc from '../../../images/bank-barclays.svg';
import ClearbankSrc from '../../../images/bank-clearbank.svg';
import HalifaxSrc from '../../../images/bank-halifax.svg';
import HsbcSrc from '../../../images/bank-hsbc.svg';
import LloydsSrc from '../../../images/bank-lloyds.svg';
import MetroSrc from '../../../images/bank-metro.svg';
import MonzoSrc from '../../../images/bank-monzo.svg';
import N26Src from '../../../images/bank-n26.svg';
import NationwideSrc from '../../../images/bank-nationwide.svg';
import NatwestSrc from '../../../images/bank-natwest.svg';
import BankPlaceholderSrc from '../../../images/bank-placeholder.svg';
import RbsSrc from '../../../images/bank-rbs.svg';
import RevolutSrc from '../../../images/bank-revolut.svg';
import SantanderSrc from '../../../images/bank-santander.svg';
import StandardCharteredBankSrc from '../../../images/bank-standard-chartered-bank.svg';
import StarlingSrc from '../../../images/bank-starling.svg';
import TandemSrc from '../../../images/bank-tandem.svg';
import TransferwiseSrc from '../../../images/bank-transferwise.svg';
import TsbSrc from '../../../images/bank-tsb.svg';
import VirginSrc from '../../../images/bank-virgin.svg';
import { Box } from '../box/box';

import * as styles from './bank-logos.css';

type Size = keyof typeof styles.logoSize;

interface BankLogoProps {
  src: string;
  alt: string;
  size?: Size;
}

const BankLogo = ({ size = 'l', ...props }: BankLogoProps) => {
  return (
    <Box
      Component="span"
      variant="initial"
      rounded
      background="neutral100"
      padding="baseNeg6"
      className={styles.logoWrapper}
    >
      <img
        {...props}
        height="40"
        width="40"
        className={classFilter([styles.logoSize[size]])}
      />
    </Box>
  );
};

export const Atom = ({ size }: { size?: Size }) => {
  return <BankLogo src={AtomSrc} alt="Atom Bank" size={size} />;
};

export const BankOfScotland = ({ size }: { size?: Size }) => {
  return (
    <BankLogo src={BankOfScotlandSrc} alt="Bank of Scotland" size={size} />
  );
};

export const Barclays = ({ size }: { size?: Size }) => {
  return <BankLogo src={BarclaysSrc} alt="Barclays" size={size} />;
};

export const Clearbank = ({ size }: { size?: Size }) => {
  return <BankLogo src={ClearbankSrc} alt="Clearbank" size={size} />;
};

export const Halifax = ({ size }: { size?: Size }) => {
  return <BankLogo src={HalifaxSrc} alt="Halifax Bank" size={size} />;
};

export const Hsbc = ({ size }: { size?: Size }) => {
  return <BankLogo src={HsbcSrc} alt="HSBC" size={size} />;
};

export const Lloyds = ({ size }: { size?: Size }) => {
  return <BankLogo src={LloydsSrc} alt="Lloyds Bank" size={size} />;
};

export const Metro = ({ size }: { size?: Size }) => {
  return <BankLogo src={MetroSrc} alt="Metro Bank" size={size} />;
};

export const Monzo = ({ size }: { size?: Size }) => {
  return <BankLogo src={MonzoSrc} alt="Monzo Bank" size={size} />;
};

export const N26 = ({ size }: { size?: Size }) => {
  return <BankLogo src={N26Src} alt="N26" size={size} />;
};

export const Nationwide = ({ size }: { size?: Size }) => {
  return (
    <BankLogo
      src={NationwideSrc}
      alt="Nationwide Building Society"
      size={size}
    />
  );
};

export const Natwest = ({ size }: { size?: Size }) => {
  return <BankLogo src={NatwestSrc} alt="Natwest Bank" size={size} />;
};

export const BankPlaceholder = ({
  size,
  alt,
}: {
  size?: Size;
  alt: string;
}) => {
  return <BankLogo src={BankPlaceholderSrc} alt={alt} size={size} />;
};

export const Rbs = ({ size }: { size?: Size }) => {
  return <BankLogo src={RbsSrc} alt="RBS" size={size} />;
};

export const Revolut = ({ size }: { size?: Size }) => {
  return <BankLogo src={RevolutSrc} alt="Revolut" size={size} />;
};

export const Santander = ({ size }: { size?: Size }) => {
  return <BankLogo src={SantanderSrc} alt="Santander Bank" size={size} />;
};

export const StandardCharteredBank = ({ size }: { size?: Size }) => {
  return (
    <BankLogo
      src={StandardCharteredBankSrc}
      alt="Standard Chartered Bank"
      size={size}
    />
  );
};

export const Starling = ({ size }: { size?: Size }) => {
  return <BankLogo src={StarlingSrc} alt="Starling Bank" size={size} />;
};

export const Tandem = ({ size }: { size?: Size }) => {
  return <BankLogo src={TandemSrc} alt="Tandem Bank" size={size} />;
};

export const Transferwise = ({ size }: { size?: Size }) => {
  return <BankLogo src={TransferwiseSrc} alt="Transferwise" size={size} />;
};

export const Tsb = ({ size }: { size?: Size }) => {
  return <BankLogo src={TsbSrc} alt="TSB" size={size} />;
};

export const Virgin = ({ size }: { size?: Size }) => {
  return <BankLogo src={VirginSrc} alt="Virgin Bank" size={size} />;
};
